<script setup lang="ts">
  import { onMounted, PropType, ref, watch } from 'vue'

  import { Modal } from 'bootstrap'

  const modal = ref<InstanceType<typeof Modal> | null>(null)

  const props = defineProps({
    title: {
      type: String,
      required: true,
    },
    contentList: {
      type: Array as () => string[],
      required: true,
    },
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: false,
      default: () => void 0,
    },
  })

  onMounted(() => {
    modal.value = new Modal('#modal-general-tips', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  watch(
    () => props.show,
    (newValue) => {
      if (newValue) {
        modal.value?.show()
      }
    },
  )

  function hide() {
    modal.value?.hide()
    setTimeout(() => {
      props.onClose?.()
    }, 300)
  }

  function showModal() {
    modal.value?.show()
  }

  defineExpose({ hide, show: showModal })
</script>

<template>
  <div
    id="modal-general-tips"
    class="modal modal-md fade"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content tips-modal-content">
        <div class="modal-header pb-3 border-bottom">
          <h5 class="modal-title modal-title text-[#2F3242]">
            O que é {{ title }}?
          </h5>

          <button
            class="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Fechar"
          ></button>
        </div>
        <div class="modal-body py-3">
          <p
            v-for="(content, index) in contentList"
            :key="index"
            :class="{
              'mv-2': index !== 0 && index !== contentList.length - 1,
            }"
          >
            {{ content }}
          </p>
        </div>
        <div class="modal-footer py-3">
          <button class="btn btn-primary" type="button" @click="hide">
            <span>Fechar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-title {
    font-size: 1.5rem;
  }

  .tips-modal-content {
    max-width: 400px;
    width: 400px;
  }
</style>
